/**
 * Need Prayer page: Нужна молитва — запись на молитвенное служение.
 */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "../../components/layout/index.ts";
import { IconTelegram } from "../../components/Icons.tsx";
import { getTelegram } from "../../lib/telegram.ts";

const TELEGRAM_USERNAME = "AlinaMylnikova17";
const TELEGRAM_URL = `https://t.me/${TELEGRAM_USERNAME}`;

const BODY_TEXT = `Дорогие друзья!

Если Вы ищите Божиих ответов, у Вас есть нужда или молитвенная просьба — мы готовы послужить: помолиться онлайн в удобное для Вас время.

В процессе молитвенного служения Господь дает пророческое Слово, видения, исцеления и ответы на сложные жизненные вопросы. Евангелие от Матфея 21:22: «и все, чего ни попросите в молитве с верою, получите».

Записывайтесь на молитву по кнопке ниже, мы рады послужить Вам!`;

function buildImageUrl(url: string | null | undefined): string | null {
  if (!url?.trim()) return null;
  if (url.startsWith("http")) return url;
  return url.startsWith("/") ? url : `/${url}`;
}

export function NeedPrayerPage() {
  const navigate = useNavigate();
  const tg = getTelegram();
  const imageUrl = buildImageUrl("/content/want-to-prayer.png");

  useEffect(() => {
    if (!tg) return;
    tg.BackButton.show();
    const handleBack = () => {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate("/");
      }
    };
    tg.BackButton.onClick(handleBack);
    return () => {
      tg.BackButton.offClick(handleBack);
      tg.BackButton.hide();
    };
  }, [tg, navigate]);

  const handleTelegramClick = (e: React.MouseEvent) => {
    if (tg?.openLink) {
      e.preventDefault();
      tg.openLink(TELEGRAM_URL);
    }
  };

  return (
    <Layout>
      <h1 className="text-xl font-bold text-slate-800 mb-4">Нужна молитва</h1>

      {/* Hero image */}
      {imageUrl ? (
        <div className="aspect-[4/3] overflow-hidden rounded-2xl mb-4 shadow-sm border border-slate-100 ring-1 ring-slate-200/50 bg-slate-100">
          <img src={imageUrl} alt="" className="w-full h-full object-cover" />
        </div>
      ) : null}

      {/* Description */}
      <div className="rounded-2xl overflow-hidden bg-white/95 shadow-sm p-4 xs:p-5 mb-6 border border-slate-100">
        <p className="text-slate-600 text-sm leading-relaxed whitespace-pre-wrap prose prose-slate prose-sm max-w-none">
          {BODY_TEXT}
        </p>
      </div>

      {/* Кнопка: записаться на молитву — переход в личку Telegram */}
      <a
        href={TELEGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleTelegramClick}
        className="flex items-center justify-center gap-3 py-4 px-4 rounded-xl bg-[#0088cc] text-white shadow-sm border border-[#0088cc]/80 active:opacity-90 transition-colors no-underline"
      >
        <IconTelegram className="w-6 h-6 flex-shrink-0" />
        <span className="font-medium">Записаться на молитву</span>
        <span className="text-white/80 text-sm">@{TELEGRAM_USERNAME}</span>
      </a>

      <div className="h-4" />
    </Layout>
  );
}
